import SetAuthorEmailForm from '@/views/common/account/base-info/set-author-email-form.vue';
export const useSetAuthorEmailModal = () => {
  const {
    openEditor
  } = useComponentModal();
  const showSetAuthorEmailModal = title => {
    return openEditor(title, SetAuthorEmailForm, {}, {
      width: '600px',
      showMaximize: false,
      showMinimize: false
    });
  };
  return {
    showSetAuthorEmailModal
  };
};